import { createFileRoute } from "@tanstack/react-router";
import CreateListingAIReview from "@/pages/dashboard/CreateListingAIReview";
import SubscribedRoute from "@/components/shared/SubscribedRoute";

export const Route = createFileRoute("/dashboard/create-listing-ai/review/$draftId/")({
  head: () => ({
    meta: [
      { title: "Verifică anunțul generat cu AI | RO Auto Market" },
      {
        name: "description",
        content: "Confirmă datele detectate din videoclip înainte de publicarea anunțului.",
      },
      { name: "robots", content: "noindex, nofollow" },
      { property: "og:title", content: "Verifică anunțul generat cu AI" },
      {
        property: "og:description",
        content: "Confirmă datele detectate din videoclip înainte de publicare.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <SubscribedRoute>
      <CreateListingAIReview />
    </SubscribedRoute>
  );
}
